import { RosterTypes } from '@/types';

export interface RosterTypeRecordResult {
  id: number;
  label: string;
}

export const ROSTER_TYPES_WITH_IDS: Record<RosterTypes, RosterTypeRecordResult> = {
  Rostered: { id: 1, label: 'Rostered' },
  Captain: { id: 2, label: 'Captain' },
  'Set-up': { id: 3, label: 'Set-up' },
  'Pack-up': { id: 4, label: 'Pack-up' },
  Scrapper: { id: 7, label: 'Scrapper' },
  Scrutineer: { id: 5, label: 'Scrutineer' },
  'Self-rostered': { id: 6, label: 'Self-rostered' },
};
